import React from 'react';
import MainLayoutDesktop from 'layouts/main-layout/main-layout.desktop';
import StaticPageSidebar from 'components/static-page-sidebar';
import Container from 'atomic/container';
import Box from 'atomic/box';
import Newsletter from 'components/newsletter';

import './static-page-layout.desktop.scss';

type StaticPageLayoutDesktopProps = {
    children: React.ReactNode;
};

const StaticPageLayoutDesktop: React.FC<StaticPageLayoutDesktopProps> = ({ children }) => (
    <MainLayoutDesktop
        disableAdSlots={true}
    >
        <Container className="static-page">
            <Box className="static-page__sidebar">
                <StaticPageSidebar />
            </Box>
            <Box className="static-page__content">
                {children}
            </Box>
        </Container>
        <Newsletter isMobile={false} />
    </MainLayoutDesktop>
);

export default React.memo(StaticPageLayoutDesktop) as React.FC<StaticPageLayoutDesktopProps>;
